import { Component } from 'react'
import { mvToBar, barToMv } from '../../../utils/piezo'
import { getString } from '../../../locale'
import classnames from 'classnames'

type Props = {
    label: string
    value: number | string
    onInput: (value: string) => void
    error: boolean
    errorRenderer: () => JSX.Element | boolean
    className?: string
}

type State = {
    pressure: number | string
}

class PressureInput extends Component<Props, State> {
    state: State = {
        pressure: mvToBar(Number(this.props.value)),
    }

    componentDidUpdate = (prevProps: Props) => {
        if (prevProps.value !== this.props.value) {
            this.setState({ pressure: mvToBar(Number(this.props.value)) })
        }
    }

    handleMvInput(e: any) {
        this.props.onInput(e.target.value)
        this.setState({ pressure: mvToBar(Number(this.props.value)) })
    }

    handleBarInput(e: any) {
        this.setState({ pressure: e.target.value })
        this.props.onInput(String(barToMv(Number(e.target.value))))
    }

    render() {
        return (
            <>
                <div className={classnames('grid grid-cols-1', this.props.className)}>
                    <div className="hidden">
                        <label className="dark:text-white text-sm">
                            {this.props.label} ({getString('common.mv')})
                        </label>
                        <input
                            className={classnames('pretty-input', this.props.error ? 'border-red-500' : 'border-gray-300')}
                            value={this.props.value}
                            type="number"
                            onInput={this.handleMvInput.bind(this)}
                        />
                    </div>
                    <div>
                        <label className="dark:text-white text-sm">
                            {this.props.label} ({getString('common.bar')})
                        </label>
                        <input
                            className={classnames('pretty-input', this.props.error ? 'border-red-500' : 'border-gray-300')}
                            value={this.state.pressure}
                            type="number"
                            onInput={this.handleBarInput.bind(this)}
                        />
                    </div>
                </div>
                {this.props.errorRenderer()}
            </>
        )
    }
}

export default PressureInput
